import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Enable full-width grid layout (same effect as tixxt--full.full-content
    // in application.html.haml, but without modifying the layout file).
    // See useFullWidthLayout hook for the React equivalent.
    document.body.classList.add("tixxt--full", "full-content");

    // Force a full page reload when navigating away.
    // Without this, TurboCompat converts the navigation into a SPA toggle
    // (hiding #turbo-root instead of replacing it), leaving stale styles
    // and Tableau SDK state in the DOM.
    // Capture phase runs before TurboCompat's bubble-phase listener on window.
    this.forceReloadOnLeave = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(event.detail.url);
    };
    document.addEventListener(
      "turbo:before-visit",
      this.forceReloadOnLeave,
      true,
    );
  }

  disconnect() {
    document.body.classList.remove("tixxt--full", "full-content");

    document.removeEventListener(
      "turbo:before-visit",
      this.forceReloadOnLeave,
      true,
    );
  }
}
